import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function getIrisDialogPlacementId(): string | undefined {
    if (isGlobalFeatureEnabled('growth-iris-dialog-test')) {
        return '88001061';
    }
    return isGlobalFeatureEnabled('growth-iris-dialog') ? '88001060' : undefined;
}

export function isIrisDialogEnabled(): boolean {
    return getIrisDialogPlacementId() !== undefined;
}
